var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.issystemNotification)?_c('v-alert',{attrs:{"dense":"","type":"error","color":"#4cc6b5"}},_vm._l((_vm.infoText),function(msg,index){return _c('span',{key:index},[_vm._v(_vm._s(msg)),_c('br')])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }